import { useQuery } from '@apollo/client/react';

import {
  OnboardingCostSummariesDocument,
  OnboardingCostSummaryFragment,
  PricingSetFragment,
} from '@graphql/platform';

import {
  CHALLENGER_RATE_GROUP_KINDS,
  challengerInclusionPlanIds,
} from './use_challenger_plan_pricing_cache';

/**
 * Onboarding labor summaries for all slider plans — served from Apollo cache
 * after ZIP prefetch so complimentary hours update without refetching.
 */
export const useChallengerOnboardingCostSummaries = (
  pricingSet?: PricingSetFragment,
) => {
  const planIds = challengerInclusionPlanIds(pricingSet);
  const pricingSetId = pricingSet?.id;

  return useQuery(OnboardingCostSummariesDocument, {
    variables: {
      pricingSetId: pricingSetId ?? '',
      planIds: planIds.length > 0 ? planIds : [''],
      rateGroupKinds: [...CHALLENGER_RATE_GROUP_KINDS],
    },
    skip: !pricingSetId || planIds.length === 0,
    fetchPolicy: 'cache-first',
  });
};

export const onboardingSummariesForPlan = (
  summaries: ReadonlyArray<OnboardingCostSummaryFragment> | undefined,
  planId: string | undefined,
): OnboardingCostSummaryFragment[] | undefined => {
  if (!planId || !summaries?.length) return undefined;

  const rows = summaries.filter((row) => row.planId === planId);
  return rows.length > 0 ? rows : undefined;
};
